import React, { useMemo } from 'react';
import PuckColorField from './PuckColorField.jsx';
import { usePuckRichTextStyle } from '../../context/PuckRichTextStyleContext';

/**
 * Sélecteur de couleur pour le fond d'une zone de texte riche Puck.
 * Valeur vide = transparent (option intégrée au picker, cf. PuckColorField).
 */
export default function TextBackgroundColorField({ value = '', onChange, label = 'Couleur de fond' }) {
  const { swatches } = usePuckRichTextStyle();
  const swatchColors = useMemo(() => {
    const colors = swatches.map((s) => s.value).filter(Boolean);
    if (!colors.some((h) => h.toLowerCase() === '#ffffff' || h.startsWith('#fff'))) {
      return ['#ffffff', ...colors];
    }
    return colors;
  }, [swatches]);

  return (
    <PuckColorField
      label={label}
      value={value}
      onChange={(v) => onChange(v || '')}
      swatches={swatchColors}
      size="sm"
      allowTransparent
    />
  );
}
